/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */


import { ProductUnion } from "../types/ProductUnion";

export const isFlexServiceProduct = (product: ProductUnion) =>
  product.caseCategory === "advisory" &&
  ((product.caseInsurance.specialTermsTag && product.caseInsurance.specialTermsTag === "advocardFlex") ||
    product.landingPage === "FlexService");
